export { default } from './RecentlyReturned';



// WEBPACK FOOTER //
// ./app/components/borrowing/recentlyreturned/RecentlyReturned/index.js